import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Product } from '@vestiaire/api-sdk-angular';
import { AddToCartModalComponent, AddToCartModalData } from '@app/core/cart/components';
import { ClosePopin } from './../../../store/actions/popin.action';
import { Store } from '@ngrx/store';
import { IAppState } from '@app/store';

@Injectable()
export class CartDialogService {
  constructor(private dialog: MatDialog, private store: Store<IAppState>) {}

  private buildConfig(data: AddToCartModalData): MatDialogConfig<AddToCartModalData> {
    return { disableClose: false, maxWidth: 600, data };
  }

  confirmAddToCart(product?: Product): void {
    this.dialog
      .open(AddToCartModalComponent, this.buildConfig({ product }))
      .afterClosed()
      .subscribe(
        () => {
          this.store.dispatch(new ClosePopin({ name: 'AddToCart' }));
        },
        err => {}
      );
  }

  addToCartError(error): void {
    this.dialog
      .open(
        AddToCartModalComponent,
        this.buildConfig({
          error: true,
          errorMessage: error.detail
        })
      )
      .afterClosed()
      .subscribe(
        () => {
          this.store.dispatch(new ClosePopin({ name: 'AddToCart' }));
        },
        err => {}
      );
  }
}
